import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthActions } from "@convex-dev/auth/react";
import { AuthForm, InputField } from "../components/AuthForm";

export function SignInPage() {
  const { signIn } = useAuthActions();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Check if signups are enabled via environment variable
  const signupsEnabled = import.meta.env.VITE_ENABLE_SIGNUPS === "true";

  const handleSignIn = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      await signIn("password", {
        email,
        password,
        flow: "signIn",
      });
      // Successfully signed in, redirect to home
      navigate("/");
    } catch (err: any) {
      setError(err.message || "Invalid email or password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthForm
      title="Sign In"
      onSubmit={handleSignIn}
      submitLabel="Sign In"
      isLoading={isLoading}
      error={error}
      footer={
        <div className="space-y-2">
          <p>
            <Link
              to="/forgot-password"
              className="text-blue-600 hover:underline"
            >
              Forgot your password?
            </Link>
          </p>
          {signupsEnabled && (
            <p>
              Don't have an account?{" "}
              <Link to="/signup" className="text-blue-600 hover:underline">
                Sign Up
              </Link>
            </p>
          )}
        </div>
      }
    >
      <InputField
        label="Email"
        type="email"
        value={email}
        onChange={setEmail}
        placeholder="Enter your email"
        autoComplete="email"
      />

      <InputField
        label="Password"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder="Enter your password"
        autoComplete="current-password"
      />
    </AuthForm>
  );
}
